import React, { useState } from "react";
import "./ProductsSlider.css";
import ProductCard from "./ProductCard";
import Container from "../Container";
import ProductModal from "./ProductModal";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import data from '../../data/data.json'

const ProductsSlider = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Splide will handle perPage responsively via breakpoints.
  const sliderOptions = {
    type: 'loop',
    autoplay: true,
    perPage: 3,
    perMove: 1,
    speed: 2000,
    gap: '1rem',
    height: 'auto',
    pagination: false,
    focus: 'center', // keep current slide centered
    breakpoints: {
      1280: { perPage: 3 },
      1024: { perPage: 3 },
      800: { perPage: 2 },
      640: { perPage: 1 },
    },
  };

  const toggleModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(!isModalOpen);
  };

  return (
    <Container>
      <div className="products">
        <Splide
          aria-label="My Favorite Images"
          options={sliderOptions}
          className="splide-carousel"
        >
          {data.map((product, index) => (
            <SplideSlide className="splide-container" key={index}>
              <ProductCard
                key={index}
                title={product.title}
                price={product.price}
                imageSrc={product.imageSrc}
                featured={product.featured}
                productId={product.productId}
                onQuickViewClick={() => toggleModal(product)}
              />
            </SplideSlide>
          ))}
        </Splide>
      </div>

      {isModalOpen && (
        <ProductModal
          onClose={() => setIsModalOpen(false)}
          {...selectedProduct}
        />
      )}
    </Container>
  );
};

export default ProductsSlider;
